module.exports = __webpack_public_path__ + "img/recuperation.70864bdd.png";